import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React, { FC } from 'react'
import { ButtonWithLoading } from '@e3dc-react/shell/Elements/Buttons/Buttons'
import { useDebouncedCallback } from 'use-debounce'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'

import { SettingsBox } from 'src/Elements/Data'

interface Props {
  isInfinityUpdatePossible: boolean
  isRunInfinityUpdateLoading: boolean
  runInfinityUpdate: () => void
}

const useStyles = makeStyles()(theme => ({
  contentAccordion: {
    padding: theme.spacing(0),
  },
  headerContent: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(4),
    },
  },
  accordionContent: {
    padding: theme.spacing(4),
    paddingBottom: theme.spacing(2),
  },
}))

/**
 * Handles infinity updates for systems
 */
const InfinityUpdate: FC<Props> = ({ isInfinityUpdatePossible, isRunInfinityUpdateLoading, runInfinityUpdate }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  const debouncedRequestHandler = useDebouncedCallback(() => {
    runInfinityUpdate()
  }, 400)

  if (!isInfinityUpdatePossible) {
    return null
  }

  return (
    <AccordionItem
      contentClassName={classes.contentAccordion}
      headerContentClassName={classes.headerContent}
      title={t('installation-settings.infinity-update.accordion-title')}
      expanded
    >
      <Box className={classes.accordionContent}>
        <SettingsBox
          title={t('installation-settings.infinity-update.title')}
          suffix={
            <ButtonWithLoading
              isLoading={isRunInfinityUpdateLoading}
              variant="contained"
              onClick={debouncedRequestHandler.callback}
              label={t('installation-settings.infinity-update.button-text')}
            />
          }
        />
      </Box>
    </AccordionItem>
  )
}

export default InfinityUpdate
